export default "__VITE_PUBLIC_ASSET__933d578f__"